import { getOrganizationDocRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreOrganizationRepository extends BaseFirestoreRepository {
  async upsertEntity(entity) {
    return this.upsert(
      getOrganizationDocRef(this.db, entity.id),
      this.addStorageMarker(entity)
    );
  }

  async deleteEntity(entityId) {
    return this.delete(getOrganizationDocRef(this.db, entityId));
  }
}
